// Shared visual shell for compliance / legal pages.
// Same dark amber theme + Space Grotesk font as the rest of the app.
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";

export default function LegalShell({ title, eyebrow, lastUpdated, testid, children }) {
  return (
    <main
      data-testid={testid}
      className="min-h-screen px-6 sm:px-10 lg:px-20 py-12 max-w-3xl mx-auto"
    >
      <Link
        href="/"
        data-testid="legal-back-link"
        className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-amber-300 mb-10 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" /> back to home
      </Link>

      <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-amber-300">
        {eyebrow}
      </p>
      <h1 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-50 break-words">
        {title}
      </h1>
      {lastUpdated && (
        <p
          data-testid="legal-last-updated"
          className="mt-3 font-mono text-[12px] text-zinc-500"
        >
          Last updated: {lastUpdated}
        </p>
      )}

      <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-zinc-300 min-w-0 break-words">
        {children}
      </div>
    </main>
  );
}

export function Section({ id, heading, children }) {
  return (
    <section id={id} className="space-y-3">
      <h2 className="text-lg sm:text-xl font-semibold text-zinc-100">{heading}</h2>
      <div className="text-zinc-400 space-y-3">{children}</div>
    </section>
  );
}
